

























import { ParagraphSize, RainbowColor } from '@getaccept/lib-ui';
import { defineComponent } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { PathName } from '@getaccept/lib-shared/src/enums/PathNames';

export default defineComponent({
  emits: ['contact'],
  setup() {
    return {
      ParagraphSize,
      RainbowColor,
      PathName,
      t,
    };
  },
});
